// 节点「上次使用的模型 + 参数」记忆
// 按节点类型（image / video / audio / text）各存一份最近一次的快照，
// 新建同类型节点时回填，避免每次都归零到模型的原始默认值。
// 分镜大师节点（storyboardMode）不参与，由调用方负责排除。
// 存 localStorage：与项目既有习惯一致（scriptMasterSize、字体缓存），逐设备、无需后端。

const STORAGE_KEY = 'cineart_node_defaults_v1';

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {};
  } catch (e) {
    return {};
  }
}

// 读取某类型上次的快照：{ modelId, modelName, modelLogo, params } 或 null
export function readNodeDefaults(type) {
  if (!type) return null;
  const all = readAll();
  const snapshot = all[type] || null;
  if (!snapshot) return null;

  // 排除 LoRA 参数，不继承到新节点
  if (snapshot.params && snapshot.params.loraStrengths) {
    const { loraStrengths, ...restParams } = snapshot.params;
    return {
      ...snapshot,
      params: restParams
    };
  }

  return snapshot;
}

// 覆盖写入某类型的最近一次快照
export function writeNodeDefaults(type, snapshot) {
  if (!type || !snapshot || !snapshot.modelId) return;
  try {
    const all = readAll();
    all[type] = {
      modelId: snapshot.modelId,
      modelName: snapshot.modelName || '',
      modelLogo: snapshot.modelLogo || '',
      params: snapshot.params ? { ...snapshot.params } : {},
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  } catch (e) {
    /* localStorage 写满 / 隐私模式下静默降级 */
  }
}

// 比例 → 重排朝向后的尺寸，与 NodeConsole 的 ratioToPreviewSizeWithCurrent 一致：
//   统一使用短边固定 300 的策略，与 calculateLongSide120 保持一致。
export function ratioOrientationSize(ratio, currentSize, isStoryboard = false) {
  if (!ratio || !currentSize) return null;
  const raw = String(ratio).toLowerCase();
  if (raw === 'portrait') ratio = '9:16';
  else if (raw === 'landscape') ratio = '16:9';

  let w, h;
  const px = String(ratio).match(/^(\d+)\s*[xX×]\s*(\d+)$/);
  if (px) {
    w = parseFloat(px[1]);
    h = parseFloat(px[2]);
  } else {
    const parts = String(ratio).split(':');
    if (parts.length !== 2) return null;
    w = parseFloat(parts[0]);
    h = parseFloat(parts[1]);
  }
  if (!w || !h || w <= 0 || h <= 0) return null;

  // 统一使用短边固定 240 的策略
  const SHORT = 240;

  if (isStoryboard) {
    // 分镜草图：固定短边（保持原逻辑，但使用当前尺寸作为基准）
    const curW = currentSize.width || 320;
    const curH = currentSize.height || 240;
    const short = Math.min(curW, curH);
    if (w >= h) return { width: Math.round(short * (w / h)), height: short };
    return { width: short, height: Math.round(short * (h / w)) };
  }
  // 普通节点：固定短边 300（与导入图片、手动选择比例逻辑统一）
  if (w >= h) {
    // 横屏：短边是高，固定 300
    return { width: Math.round(SHORT * (w / h)), height: SHORT };
  } else {
    // 竖屏：短边是宽，固定 300
    return { width: SHORT, height: Math.round(SHORT * (h / w)) };
  }
}

